import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getBlockTypes } from 'actions/blocks';
import { HaldorBlockEditor, SkolonBlock, translate } from '@haldor/ui';
import AssignmentBlock from './Blocks/AssignmentBlock';
import FileBlock from './Blocks/FileBlock';
import LinksBlock from './Blocks/LinksBlock';
import NDLABlock from './Blocks/NdlaBlock';

var BlockEditor = /*#__PURE__*/function (_Component) {
  _inherits(BlockEditor, _Component);

  var _super = _createSuper(BlockEditor);

  function BlockEditor() {
    var _this;

    _classCallCheck(this, BlockEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.types == null) {
        _this.props.getBlockTypes();
      }
    });

    return _this;
  }

  _createClass(BlockEditor, [{
    key: "render",
    value: function render() {
      if (this.props.types == null) {
        return null;
      }

      var plugins = [];

      if (this.props.types.indexOf('Haldor.Blocks.Link') > -1) {
        plugins.push(LinksBlock);
      }

      if (this.props.types.indexOf('Haldor.Blocks.Assignment') > -1) {
        plugins.push(AssignmentBlock);
      }

      if (this.props.types.indexOf('Haldor.Blocks.File') > -1) {
        plugins.push(FileBlock);
      }

      if (this.props.types.indexOf('Haldor.Blocks.Skolon') > -1) {
        plugins.push(SkolonBlock);
      }

      if (this.props.types.indexOf('Haldor.Blocks.NDLA') > -1) {
        plugins.push(NDLABlock);
      }

      return /*#__PURE__*/React.createElement(HaldorBlockEditor, _extends({
        plugins: plugins,
        disabledBlocks: this.props.disabled,
        translate: this.props.translate
      }, this.props));
    }
  }]);

  return BlockEditor;
}(Component);

function mapStateToProps(state) {
  return {
    types: state.Blocks.types,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getBlockTypes: getBlockTypes
})(BlockEditor);